<script setup lang="ts">
/**
 * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [SigningWithoutSms]
 */

import { ref, useCssModule } from "vue";

import Modal from "@/components/modal/modal.vue";
import StepsButtons from "@/components/StepsButtons/StepsButtons.vue";
import useTranslate from "@/hooks/useTranslate/useTranslate";
import { useTIWStore } from "@/stores/tiw/tiw";
import AwardIcon from "@/ui/icons/award.vue";

const classes = useCssModule();

const TIWStore = useTIWStore();

const loadingToNext = ref<boolean>(false);

function clickToNext() {
    TIWStore.switchStep("thanksYou");
}
</script>

<template>
    <Modal class="tiw__step__signingWithoutSms">
        <template #header>
            <p class="tiw__step__signingWithoutSms__header tiw__h2">
                <AwardIcon />
                {{ useTranslate("tiw__signingWithoutSms__title") }}
            </p>

            <div class="tiw__step__signingWithoutSms__text">
                {{ useTranslate("tiw__signingWithoutSms__subtitle") }}
            </div>

            <div v-if="false" class="tiw__step__signingWithoutSms__text">
                <div>
                    {{ useTranslate("tiw__signingWithoutSms__downloadContract__title") }}
                </div>
                <div class="tiw__step__signingWithoutSms__link">
                    <svg
                        class="tiw__step__signingWithoutSms__link__icon"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
                            stroke="#808D9A"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M4.66602 6.66667L7.99935 10L11.3327 6.66667"
                            stroke="#808D9A"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M8 10V2"
                            stroke="#808D9A"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>

                    <a class="tiw__step__signingWithoutSms__link__text" href="#" target="_blank">
                        {{ useTranslate("tiw__signingWithoutSms__downloadContract") }}
                    </a>
                </div>
            </div>
        </template>

        <StepsButtons
            no-back-btn
            :disabled="loadingToNext"
            :loading="loadingToNext"
            :click-to-next="clickToNext"
            :class="classes.stepsButtons"
            :btn-class="classes.btnNext"
        />
    </Modal>
</template>

<style lang="scss" src="./signingWithoutSms.scss"></style>
<style module>
.stepsButtons {
    margin-top: 0;
}
.btnNext {
    width: 100%;
}
</style>
